import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=25eaaf38&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=25eaaf38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eaaf38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\swag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25eaaf38')) {
      api.createRecord('25eaaf38', component.options)
    } else {
      api.reload('25eaaf38', component.options)
    }
    module.hot.accept("./FAQ.vue?vue&type=template&id=25eaaf38&scoped=true&", function () {
      api.rerender('25eaaf38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Swag/components/FAQ.vue"
export default component.exports